import React, { useState } from "react";
import { Popover, Button, Group } from "@mantine/core";
import { DatePicker } from "@mantine/dates";
import useStyles from "./style";
import moment from "moment";
import { MdOutlineCalendarToday } from "react-icons/md";
import { useMediaQuery } from "@mantine/hooks";

const DateRangePicker = ({
  dateRange,
  setDateRange,
  handleApply,
  open,
  opened,
  close,
}) => {
  const { classes } = useStyles();
  const isExtraSmallScreen = useMediaQuery("(max-width: 834px)");
  const isMediumScreen = useMediaQuery("(max-width:992px)");
  const [isDateRangeValid, setIsDateRangeValid] = useState(true);

  const handleRange = (dates) => {
    if (dates && dates[0] && dates[1]) {
      const startOfDay = new Date(dates[0]).setHours(0, 0, 0, 0);
      const endOfDay = new Date(dates[1]).setHours(23, 59, 59, 999);

      const adjustedDates = [new Date(startOfDay), new Date(endOfDay)];

      setDateRange({ type: "custom", date: adjustedDates });
      setIsDateRangeValid(true);
    } else {
      setDateRange({ type: "custom", date: dates });
      setIsDateRangeValid(false);
    }
  };

  const handleThisMonth = () => {
    let date = new Date();
    let year = date.getFullYear();
    let month = date.getMonth();
    let firstDay = new Date(year, month, 1);
    let lastDay = new Date();
    setDateRange({ type: "this month", date: [firstDay, lastDay] });
  };

  const handleLastMonth = () => {
    let date = new Date();
    let year = date.getFullYear();
    let month = date.getMonth() - 1;
    let firstDay = new Date(year, month, 1);
    let lastDay = new Date(year, month + 1, 0);
    setDateRange({ type: "last month", date: [firstDay, lastDay] });
  };

  const handleThisYear = () => {
    const currentYear = new Date().getFullYear();
    const firstDayOfYear = new Date(currentYear, 0, 1);
    const lastDayOfYear = new Date()
    setDateRange({ type: "this year", date: [firstDayOfYear, lastDayOfYear] });
  };

  const handleCustomRange = () => {
    setIsDateRangeValid(false);
    setDateRange({ type: "custom", date: [] });
  };

  const handleClose = () => {
    setDateRange({ type: "", date: [] });
    setIsDateRangeValid(true);
    close();
  };

  const isActive = (type) => dateRange.type === type;

  return (
    <Group justify="end">
      <Popover
        shadow="md"
        onClose={close}
        opened={opened}
        width={isExtraSmallScreen ? 310 : 450}
        position="bottom-start"
        middlewares={{ flip: true, shift: true, inline: false }}
        withinPortal
        zIndex={1001}
      >
        <Popover.Target>
          <Button className={classes.buttonStyle} onClick={open}>
            <MdOutlineCalendarToday
              className={classes.iconCalendar}
              size={18}
            />
            {dateRange?.date[0] && dateRange?.date[1]
              ? `${moment(dateRange?.date[0]).format("ll")} - ${moment(
                  dateRange?.date[1]
                ).format("ll")}`
              : "Select Date Range"}
          </Button>
        </Popover.Target>
        <Popover.Dropdown className={classes.popOverCard}>
          <div className={classes.datePickerParent}>
            <div className={classes.buttonsParent}>
              <Button
                onClick={() => handleThisMonth()}
                className={`${classes.dateButtons} ${
                  isActive("this month") ? classes.activeButton : ""
                }`}
              >
                This month
              </Button>
              <Button
                onClick={() => handleLastMonth()}
                className={`${classes.dateButtons} ${
                  isActive("last month") ? classes.activeButton : ""
                }`}
              >
                Last month
              </Button>
              <Button
                onClick={() => handleThisYear()}
                className={`${classes.dateButtons} ${
                  isActive("this year") ? classes.activeButton : ""
                }`}
              >
                This Year
              </Button>
              <Button
                className={`${classes.dateButtons} ${
                  isActive("custom") ? classes.activeButton : ""
                }`}
                onClick={() => {
                  handleCustomRange();
                }}
              >
                Custom
              </Button>
            </div>
            <div className={classes.datePickerParentDiv}>
              <DatePicker
                type="range"
                maxDate={new Date()}
                allowSingleDateInRange
                onChange={handleRange}
                value={dateRange?.date}
                label="Select dates range"
                placeholder="Select dates range"
                className={classes.datePicker}
                 withOutsideDays   // 👈 IMPORTANT
              />
              <div className={classes.bottomButtonsParent}>
                <Button
                  onClick={handleClose}
                  className={`${classes.bottomButtons} ${classes.cancelButton}`}
                >
                  Cancel
                </Button>
                <Button
                  onClick={handleApply}
                  disabled={!isDateRangeValid}
                  className={`${classes.bottomButtons} ${classes.applyButton}`}
                >
                  Apply
                </Button>
              </div>
            </div>
          </div>
        </Popover.Dropdown>
      </Popover>
    </Group>
  );
};

export default DateRangePicker;
